// Fire power multipliers:
//   Low (1)    → longer times ×1.3  — gentle simmer
//   Medium (2) → base times   ×1.0
//   High (3)   → shorter times ×0.75 — rolling boil
const POWER_MULT = { 1: 1.3, 2: 1.0, 3: 0.75 };
export function effectiveTime(baseTime, intensity) {
    return Math.round(baseTime * POWER_MULT[intensity]);
}
export function computeOrder(selections, pantry, intensity) {
    var _a;
    const items = [];
    for (const [ingId, prepId] of selections.entries()) {
        const ing = pantry.find(p => p.id === ingId);
        if (!ing)
            continue;
        const prep = (_a = ing.preparations.find(p => p.id === prepId)) !== null && _a !== void 0 ? _a : ing.preparations[0];
        items.push({
            ing,
            prep,
            time: effectiveTime(prep.time, intensity),
            addAt: 0,
            maxTime: 0,
        });
    }
    if (!items.length)
        return [];
    items.sort((a, b) => b.time - a.time);
    const maxTime = items[0].time;
    return items.map((item, i) => (Object.assign(Object.assign({}, item), { addAt: i === 0 ? 0 : maxTime - item.time, maxTime })));
}
